module.exports = __webpack_public_path__ + "static/fairchance_card_img1@2x-3750062e5768907529bbe0eff91e5076.jpg";